import { useQueryClient } from '@tanstack/react-query';
import { queryConfig } from './queryConfig';

export interface ProgramTheme {
  uid: string;
  name: string;
  icon: string;
  icon2x: string;
  logo: string;
  logo2x: string;
  strip: string;
  strip2x: string;
  label_color: string;
  text_color: string;
  background_color: string;
  hero?: string | null;
  hero_preview?: string | null;
  is_default: boolean;
  archived: boolean;
  created_at: string;
  updated_at: string;
}

export interface ProgramThemePayload {
  name: string;
  icon: string;
  icon2x: string;
  logo: string;
  logo2x: string;
  strip: string;
  strip2x: string;
  label_color: string;
  text_color: string;
  background_color: string;
  hero?: string;
  hero_preview?: string;
}

export interface RemoveThemeResult {
  status: 'archived' | 'deleted';
}

export const THEMES_KEY = 'program-themes';
const themeKey = (uid: string) => `${THEMES_KEY}-${uid}`;

export const themesUrl = '/v1/ops/programs/themes';
export const themeUrl = (uid: string) => `${themesUrl}/${encodeURIComponent(uid)}`;

const query = queryConfig({});

export const useGetProgramThemes = (params?: { page?: number; limit?: number; q?: string }) =>
  query<{ page: number; limit: number; total: number; themes: ProgramTheme[] }>({
    url: themesUrl,
    cacheKey: THEMES_KEY,
    params,
  });

export const useGetProgramTheme = (uid: string) =>
  query<ProgramTheme>({
    url: themeUrl(uid),
    cacheKey: themeKey(uid),
    enabled: uid !== '',
  });

export const useRefreshThemes = () => {
  const queryClient = useQueryClient();
  return ({ refetch = true }: { refetch?: boolean } = {}) =>
    queryClient.invalidateQueries({
      predicate: ({ queryKey }) => typeof queryKey[0] === 'string' && queryKey[0].startsWith(THEMES_KEY),
      refetchType: refetch ? 'active' : 'none',
    });
};
